<template>
    <div v-if="href"
        class="archive-link"
    >
        <button @click="toggleVideo"
            class="btn btn-mini"
            title="Play this recording"
        ><i class="icon-play"></i> Play</button>
        &nbsp;
        <a @click.prevent="toggleVideo"
            class="archive-play"
            :href="archive.url" target="_blank">
            Video recording: {{asDateTimeStamp(archive.started_at)}}
            ({{minutes}} mins)
        </a>

        <button v-if="isManager"
            @click="toggleModal"
            class="btn btn-mini btn-danger pull-right"
            title="Delete this recording"
        >
            <i class="icon-remove icon-white"></i> Delete
        </button>
        <ModalConfirm v-if="showModal"
            @confirm="deleteArchive(archive.id)"
            @cancel="toggleModal"
            button-class="btn-danger"
            button-label="Delete"
        >
            Are you sure you want to delete this recording?
        </ModalConfirm>
        <ModalVideo v-if="showVideo"
            @cancel="toggleVideo"
            :src="href"
        />
    </div>
    <div v-else
         :href="archive.url" target="_blank">
        <span v-if="archive.stopped_at">
            Video recording: {{asDateTimeStamp(archive.started_at)}} ({{minutes}}mins)
            <span>Uploading...</span>
        </span>
        <span v-else>
            <span class="archive-recording">Recording now... </span>
            <i>(started: {{asDateTimeStamp(archive.started_at)}})</i>
        </span>

    </div>
</template>

<script>
    /* @click="$emit('delete', archive.id)"
    {
        id: 1,
        archive_id: "6803f60d-bc64-4c61-83d4-dbb6d6604bc7"
        started_at: "2020-06-12T21:42:27Z"
        stopped_at: "2020-06-12T21:42:42Z"
        archived_at: null
        started_by_id: 1
        stopped_by_id: 1
        length: 15  # Length of recording in seconds
        url: "https://tok.blob.core.windows.net/video/46524522/6803f60d-bc64-4c61-83d4-dbb6d6604bc7/archive.mp4"
    }
     */
    import { asDateTimeStamp } from "./DateTime";
    import EventService from "../services/EventService";
    import ModalConfirm from "./ModalConfirm";
    import ModalVideo from "./ModalVideo";

    export default {
        name: "VideoArchiveLink",
        props: {
            archive: {
                type: Object
            }
        },
        data: function() {
            return {
                showModal: false,
                showVideo: false,
            }
        },
        computed: {
            href() {
                if (this.archive.archived_at) {
                    return this.archive.url;
                } else{
                    return null;
                }
            },
            minutes() {
                return Math.floor(this.archive.length / 60);
            },
            isManager() {
                return EventService.isManager();
            }
        },
        methods: {
            asDateTimeStamp,
            toggleModal() {
                this.showModal = !this.showModal;
            },
            toggleVideo() {
                this.showVideo = !this.showVideo;
            },
            deleteArchive(archiveId) {
                console.log(archiveId);
                return EventService.deleteVideoArchive(archiveId).then((data) => {
                    console.log(data);
                    this.$emit('reload');
                });
            },
        },
        components: {
            ModalConfirm,
            ModalVideo,
        },
    }
</script>

<style>
.archive-link {
    margin-bottom: 3px;
}
.archive-recording:before {
    display: inline-block;
    content: " \25cf ";
    color: #f00;
    display: inline-block;
    padding-right: 5px;
}
.archive-play {
    vertical-align: bottom;
}
</style>